import React, { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

//components
import CardTable from "components/CardTable/CardTable";
import Snackbars from "components/Snackbar/Snackbar.js";
import { ModalV2 } from "components/Modal/ModalV2";
import RegularButton from "components/CustomButtons/Button.js";

import { useSearch } from "hooks/useSearch";
import { useToggle } from "hooks/useToggle";

import { columns } from "./columns";
import { SearchStation } from "./SearchStation";
import { FormGasMovements } from "./gasMovementsForm/FormGasMovements";

//icons
import { TrendingUp } from "@material-ui/icons";
import AddIcon from "@mui/icons-material/Add";

//actions
import {
  configPageGasMovements,
  configPageGasMovementsSize,
  configFilterGasMovements,
  configSortedGasMovements
} from "redux/actions/gasMovementsRequests/gasMovementsRequestActions";
import { getMovements } from "redux/actions/gasMovements/gasMovActions";

export const GasMovementsRequests = () => {
  const dispatch = useDispatch();
  const { clearSnackbar } = useSearch();
  const {
    color,
    message,
    isOpen: isSnackbarOpen,
    isLoadingComp
  } = useSelector(state => state.search);
  const { gasMovements, config } = useSelector(
    state => state.gasMovementsRequests
  );
  const { movementsArr } = useSelector(({ gasMovements }) => gasMovements);

  const { filtered, page, pageSize, sorted } = config;
  const [open, setOpen] = useToggle();
  const { buildCompLoadings } = useSearch();

  const handleFilter = useCallback(e => {
    dispatch(configFilterGasMovements(e));
  }, []);

  const handleSort = useCallback(e => {
    dispatch(configSortedGasMovements(e));
  }, []);

  const handlePageItems = useCallback(e => {
    dispatch(configPageGasMovements(e));
  }, []);

  const handlePageSize = useCallback(e => {
    dispatch(configPageGasMovementsSize(e));
  }, []);

  const handleNewItem = () => {
    setOpen();
  };

  const handleCloseNewItem = () => {
    setOpen();
  };

  useEffect(() => {
    buildCompLoadings([
      "GM_RequestsLoading",
      "GM_newLoading",
      "GM_approveLoading"
    ]);
    movementsArr.length === 0 && dispatch(getMovements());
  }, []);
  return (
    <>
      <CardTable
        columns={columns}
        data={gasMovements}
        isLoading={isLoadingComp?.GM_RequestsLoading}
        hasHeader
        icon={<TrendingUp />}
        title={`Bonificación de Gas`}
        titleBlock
        blockBtn
        hasControl
        filtered={filtered}
        page={page}
        sorted={sorted}
        pageSize={pageSize}
        onFilteredChange={handleFilter}
        onPageChange={handlePageItems}
        onSortedChange={handleSort}
        onPageSizeChange={handlePageSize}
        tableContent={
          <>
            <SearchStation />
          </>
        }
        controls={
          <RegularButton
            justIcon
            round
            color="info"
            size="sm"
            tooltip="Nuevo"
            onClick={handleNewItem}
          >
            <AddIcon style={{ margin: 0 }} />
          </RegularButton>
        }
      />
      <ModalV2
        open={open}
        title={`Agregar bonificación de gas`}
        toRight
        onClose={handleCloseNewItem}
      >
        <FormGasMovements onClose={setOpen} />
      </ModalV2>
      <Snackbars
        place="tr"
        color={color}
        message={message}
        open={isSnackbarOpen}
        closeNotification={clearSnackbar}
        close
      />
    </>
  );
};
